// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImportantEvents_wrap__6dpE4 {
  position: relative;
  margin-top: 16px;
}
@media (min-width: 1200px) {
  .ImportantEvents_wrap__6dpE4 {
    margin-top: 30px;
  }
}

.ImportantEvents_slider__K8YEd {
  width: 100%;
}

.ImportantEvents_slide__1r7Gj {
  cursor: pointer;
  border: 2px solid transparent;
  border-radius: 16px;
  color: var(--accent-text-color);
  aspect-ratio: 156/96;
  padding: 2px;
  min-height: 90px;
  display: flex;
}
.ImportantEvents_slide__inner__IjZpv {
  border-radius: 12px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: auto;
  min-height: 100%;
  display: flex;
  align-items: flex-end;
  position: relative;
  padding: 10px 8px;
  width: 100%;
}
.ImportantEvents_slide__inner__IjZpv::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 20px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%);
  border-bottom-left-radius: inherit;
  border-bottom-right-radius: inherit;
}
.ImportantEvents_slide__title__nOkxI {
  position: relative;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
.ImportantEvents_slide--is-active__AcZbI {
  border-color: var(--accent-color);
}
@media (min-width: 1200px) {
  .ImportantEvents_slide__1r7Gj {
    height: 100%;
  }
}

.ImportantEvents_nav__RWEHZ {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: -10px;
  right: -10px;
}

.ImportantEvents_loaderWrap__kL-\\+g {
  display: flex;
  align-items: center;
}

.ImportantEvents_itemLoader__Aha38 {
  width: 100%;
  min-height: 90px;
  aspect-ratio: 156/96;
  border-radius: 12px;
  margin-right: 8px;
}
@media (min-width: 1200px) {
  .ImportantEvents_itemLoader__Aha38 {
    margin-right: 15px;
  }
}
.ImportantEvents_itemLoader__Aha38:last-child {
  margin-right: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/ImportantEvents/ImportantEvents.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;AACE;EAJF;IAKI,gBAAA;EAEF;AACF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,eAAA;EACA,6BAAA;EACA,mBAAA;EACA,+BAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AAEF;AAAE;EACE,mBAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAEJ;AAAI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,gFAAA;EACA,kCAAA;EACA,mCAAA;AAEN;AAEE;EACE,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAAJ;AAGE;EACE,iCAAA;AADJ;AAIE;EAlDF;IAmDI,YAAA;EADF;AACF;;AAIA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;AADF;AAGE;EAPF;IAQI,kBAAA;EAAF;AACF;AAEE;EACE,eAAA;AAAJ","sourcesContent":[".wrap {\r\n  position: relative;\r\n  margin-top: 16px;\r\n\r\n  @media (min-width: 1200px) {\r\n    margin-top: 30px;\r\n  }\r\n}\r\n\r\n.slider {\r\n  width: 100%;\r\n}\r\n\r\n.slide {\r\n  cursor: pointer;\r\n  border: 2px solid transparent;\r\n  border-radius: 16px;\r\n  color: var(--accent-text-color);\r\n  aspect-ratio: 156/96;\r\n  padding: 2px;\r\n  min-height: 90px;\r\n  display: flex;\r\n\r\n  &__inner {\r\n    border-radius: 12px;\r\n    background-repeat: no-repeat;\r\n    background-size: cover;\r\n    background-position: center;\r\n    height: auto;\r\n    min-height: 100%;\r\n    display: flex;\r\n    align-items: flex-end;\r\n    position: relative;\r\n    padding: 10px 8px;\r\n    width: 100%;\r\n\r\n    &::before {\r\n      content: '';\r\n      position: absolute;\r\n      left: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      top: 20px;\r\n      background: linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%);\r\n      border-bottom-left-radius: inherit;\r\n      border-bottom-right-radius: inherit;\r\n    }\r\n  }\r\n\r\n  &__title {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    word-break: break-all;\r\n  }\r\n\r\n  &--is-active {\r\n    border-color: var(--accent-color);\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    height: 100%;\r\n  }\r\n}\r\n\r\n.nav {\r\n  position: absolute;\r\n  top: calc(50%);\r\n  transform: translateY(-50%);\r\n  left: -10px;\r\n  right: -10px;\r\n}\r\n\r\n.loaderWrap {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.itemLoader {\r\n  width: 100%;\r\n  min-height: 90px;\r\n  aspect-ratio: 156 / 96;\r\n  border-radius: 12px;\r\n  margin-right: 8px;\r\n\r\n  @media (min-width: 1200px) {\r\n    margin-right: 15px;\r\n  }\r\n\r\n  &:last-child {\r\n    margin-right: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ImportantEvents_wrap__6dpE4`,
	"slider": `ImportantEvents_slider__K8YEd`,
	"slide": `ImportantEvents_slide__1r7Gj`,
	"slide__inner": `ImportantEvents_slide__inner__IjZpv`,
	"slide__title": `ImportantEvents_slide__title__nOkxI`,
	"slide--is-active": `ImportantEvents_slide--is-active__AcZbI`,
	"nav": `ImportantEvents_nav__RWEHZ`,
	"loaderWrap": `ImportantEvents_loaderWrap__kL-+g`,
	"itemLoader": `ImportantEvents_itemLoader__Aha38`
};
export default ___CSS_LOADER_EXPORT___;
